import { render } from "./JWTagInputV2.vue?vue&type=template&id=8f1d1daa&scoped=true&ts=true"
import script from "./JWTagInputV2.vue?vue&type=script&lang=ts"
export * from "./JWTagInputV2.vue?vue&type=script&lang=ts"

import "./JWTagInputV2.vue?vue&type=style&index=0&id=8f1d1daa&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f1d1daa"]])

export default __exports__